/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ApiAppExceptionTestBrokerExceptionGet400Response } from '../model/api-app-exception-test-broker-exception-get400-response.model';
// @ts-ignore
import { CustomerActionGuiTestResultDto } from '../model/customer-action-gui-test-result-dto.model';
// @ts-ignore
import { CustomerBrokernetMaklerSignSubmitDto } from '../model/customer-brokernet-makler-sign-submit-dto.model';
// @ts-ignore
import { CustomerBrokernetSignRequestDto } from '../model/customer-brokernet-sign-request-dto.model';
// @ts-ignore
import { CustomerBrokernetSignStatusDto } from '../model/customer-brokernet-sign-status-dto.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class CustomerActionApiService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @endpoint post /api/customer-action/{customerId}/file/{brokernetFileId}/brokernet-sign
     * @param customerId 
     * @param brokernetFileId 
     * @param customerBrokernetMaklerSignSubmitDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCustomerActionCustomerIdFileBrokernetFileIdBrokernetSignPost(customerId: string, brokernetFileId: string, customerBrokernetMaklerSignSubmitDto?: CustomerBrokernetMaklerSignSubmitDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public apiCustomerActionCustomerIdFileBrokernetFileIdBrokernetSignPost(customerId: string, brokernetFileId: string, customerBrokernetMaklerSignSubmitDto?: CustomerBrokernetMaklerSignSubmitDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public apiCustomerActionCustomerIdFileBrokernetFileIdBrokernetSignPost(customerId: string, brokernetFileId: string, customerBrokernetMaklerSignSubmitDto?: CustomerBrokernetMaklerSignSubmitDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public apiCustomerActionCustomerIdFileBrokernetFileIdBrokernetSignPost(customerId: string, brokernetFileId: string, customerBrokernetMaklerSignSubmitDto?: CustomerBrokernetMaklerSignSubmitDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling apiCustomerActionCustomerIdFileBrokernetFileIdBrokernetSignPost.');
        }
        if (brokernetFileId === null || brokernetFileId === undefined) {
            throw new Error('Required parameter brokernetFileId was null or undefined when calling apiCustomerActionCustomerIdFileBrokernetFileIdBrokernetSignPost.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/customer-action/${this.configuration.encodeParam({name: "customerId", value: customerId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/file/${this.configuration.encodeParam({name: "brokernetFileId", value: brokernetFileId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/brokernet-sign`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: customerBrokernetMaklerSignSubmitDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint get /api/customer-action/{customerId}/file/{brokernetFileId}/brokernet-sign-status
     * @param customerId 
     * @param brokernetFileId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCustomerActionCustomerIdFileBrokernetFileIdBrokernetSignStatusGet(customerId: string, brokernetFileId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CustomerBrokernetSignStatusDto>;
    public apiCustomerActionCustomerIdFileBrokernetFileIdBrokernetSignStatusGet(customerId: string, brokernetFileId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CustomerBrokernetSignStatusDto>>;
    public apiCustomerActionCustomerIdFileBrokernetFileIdBrokernetSignStatusGet(customerId: string, brokernetFileId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CustomerBrokernetSignStatusDto>>;
    public apiCustomerActionCustomerIdFileBrokernetFileIdBrokernetSignStatusGet(customerId: string, brokernetFileId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling apiCustomerActionCustomerIdFileBrokernetFileIdBrokernetSignStatusGet.');
        }
        if (brokernetFileId === null || brokernetFileId === undefined) {
            throw new Error('Required parameter brokernetFileId was null or undefined when calling apiCustomerActionCustomerIdFileBrokernetFileIdBrokernetSignStatusGet.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/customer-action/${this.configuration.encodeParam({name: "customerId", value: customerId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/file/${this.configuration.encodeParam({name: "brokernetFileId", value: brokernetFileId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/brokernet-sign-status`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CustomerBrokernetSignStatusDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /api/customer-action/{customerId}/file/{brokernetFileId}/request-brokernet-multi-signatur
     * @param customerId 
     * @param brokernetFileId 
     * @param customerBrokernetSignRequestDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCustomerActionCustomerIdFileBrokernetFileIdRequestBrokernetMultiSignaturPost(customerId: string, brokernetFileId: string, customerBrokernetSignRequestDto?: CustomerBrokernetSignRequestDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CustomerActionGuiTestResultDto>;
    public apiCustomerActionCustomerIdFileBrokernetFileIdRequestBrokernetMultiSignaturPost(customerId: string, brokernetFileId: string, customerBrokernetSignRequestDto?: CustomerBrokernetSignRequestDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CustomerActionGuiTestResultDto>>;
    public apiCustomerActionCustomerIdFileBrokernetFileIdRequestBrokernetMultiSignaturPost(customerId: string, brokernetFileId: string, customerBrokernetSignRequestDto?: CustomerBrokernetSignRequestDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CustomerActionGuiTestResultDto>>;
    public apiCustomerActionCustomerIdFileBrokernetFileIdRequestBrokernetMultiSignaturPost(customerId: string, brokernetFileId: string, customerBrokernetSignRequestDto?: CustomerBrokernetSignRequestDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling apiCustomerActionCustomerIdFileBrokernetFileIdRequestBrokernetMultiSignaturPost.');
        }
        if (brokernetFileId === null || brokernetFileId === undefined) {
            throw new Error('Required parameter brokernetFileId was null or undefined when calling apiCustomerActionCustomerIdFileBrokernetFileIdRequestBrokernetMultiSignaturPost.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/customer-action/${this.configuration.encodeParam({name: "customerId", value: customerId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/file/${this.configuration.encodeParam({name: "brokernetFileId", value: brokernetFileId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/request-brokernet-multi-signatur`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CustomerActionGuiTestResultDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: customerBrokernetSignRequestDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /api/customer-action/{customerId}/person/{personId}/request-maklervertrag-signatur
     * @param customerId 
     * @param personId 
     * @param tryRequestViaStella 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCustomerActionCustomerIdPersonPersonIdRequestMaklervertragSignaturPost(customerId: string, personId: string, tryRequestViaStella?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CustomerActionGuiTestResultDto>;
    public apiCustomerActionCustomerIdPersonPersonIdRequestMaklervertragSignaturPost(customerId: string, personId: string, tryRequestViaStella?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CustomerActionGuiTestResultDto>>;
    public apiCustomerActionCustomerIdPersonPersonIdRequestMaklervertragSignaturPost(customerId: string, personId: string, tryRequestViaStella?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CustomerActionGuiTestResultDto>>;
    public apiCustomerActionCustomerIdPersonPersonIdRequestMaklervertragSignaturPost(customerId: string, personId: string, tryRequestViaStella?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling apiCustomerActionCustomerIdPersonPersonIdRequestMaklervertragSignaturPost.');
        }
        if (personId === null || personId === undefined) {
            throw new Error('Required parameter personId was null or undefined when calling apiCustomerActionCustomerIdPersonPersonIdRequestMaklervertragSignaturPost.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>tryRequestViaStella, 'tryRequestViaStella');

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/customer-action/${this.configuration.encodeParam({name: "customerId", value: customerId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/person/${this.configuration.encodeParam({name: "personId", value: personId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/request-maklervertrag-signatur`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CustomerActionGuiTestResultDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /api/customer-action/{customerId}/person/{personId}/request-vollmacht-signatur
     * @param customerId 
     * @param personId 
     * @param tryRequestViaStella 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCustomerActionCustomerIdPersonPersonIdRequestVollmachtSignaturPost(customerId: string, personId: string, tryRequestViaStella?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CustomerActionGuiTestResultDto>;
    public apiCustomerActionCustomerIdPersonPersonIdRequestVollmachtSignaturPost(customerId: string, personId: string, tryRequestViaStella?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CustomerActionGuiTestResultDto>>;
    public apiCustomerActionCustomerIdPersonPersonIdRequestVollmachtSignaturPost(customerId: string, personId: string, tryRequestViaStella?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CustomerActionGuiTestResultDto>>;
    public apiCustomerActionCustomerIdPersonPersonIdRequestVollmachtSignaturPost(customerId: string, personId: string, tryRequestViaStella?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling apiCustomerActionCustomerIdPersonPersonIdRequestVollmachtSignaturPost.');
        }
        if (personId === null || personId === undefined) {
            throw new Error('Required parameter personId was null or undefined when calling apiCustomerActionCustomerIdPersonPersonIdRequestVollmachtSignaturPost.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>tryRequestViaStella, 'tryRequestViaStella');

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/customer-action/${this.configuration.encodeParam({name: "customerId", value: customerId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/person/${this.configuration.encodeParam({name: "personId", value: personId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/request-vollmacht-signatur`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CustomerActionGuiTestResultDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
